import { render, staticRenderFns } from "./TrustIdentityVerificationFailure.vue?vue&type=template&id=60b743ce&scoped=true"
import script from "./TrustIdentityVerificationFailure.vue?vue&type=script&lang=js"
export * from "./TrustIdentityVerificationFailure.vue?vue&type=script&lang=js"
import style0 from "./TrustIdentityVerificationFailure.vue?vue&type=style&index=0&id=60b743ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b743ce",
  null
  
)

export default component.exports